export type GetComponentResponse = {
  rootCpntDelFlg: string;
  rootCpntId: string;
  rootCpntName: string;
  dipByRgn: string;
  ownTypeCd: string;
  ownTypeName: string;
  systemName: string;
  systemId: string;
  subSystemId: string;
  notSysUsg: string;
  alctnTypeCd: string;
  alctnTypeName: string;
  clodSrvcTypeCd: string;
  clodSrvcTypeName: string;
  rgnTypeCd: string;
  rgnTypeName: string;
  acntName: string;
  updateDateTimeMRootCpnt: string;
  rootCpntIchrList: RootCpntIchr[];
  cpntDelFlg: string;
  cpntId: string;
  cpntName: string;
  cpntNameWtngChng: string;
  cpntDesc: string;
  gpgEncryptnFlg: string;
  useAssmdRoleFlg: string;
  ediUsgFlg: string;
  useEdhCnvtrFlg: string;
  hubFlg: string;
  updateDateTimeMCpnt: string;
  edhPrtclList: EdhPrtcl[];
  ifStrtMthdList: IfStrtMthd[];
  edhNtfctnTypeList: EdhNtfctnType[];
  edhPrtclInfoList: EdhPrtclInfo[];
};

export type RootCpntIchr = {
  ichrId: string;
  ichrName: string;
  pstnName: string;
  cmpnyName: string;
  telNum: string;
  mlAdrs: string;
  updateDateTimeMRootCpntIchr: string;
};
export type EdhPrtcl = {
  inOutTypeCd: string;
  inOutTypeName: string;
  edhPrtclTypeCd: string;
  edhPrtclTypeName: string;
};
export type IfStrtMthd = {
  ifStrtMthdTypeCd: string;
  ifStrtMthdTypeName: string;
};
export type EdhNtfctnType = {
  inOutTypeCd: string;
  inOutTypeName: string;
  edhNtfctnTypeCd: string;
  edhNtfctnTypeName: string;
};
export type EdhPrtclInfo = {
  cpntEdhPrtclMngDelFlg: string;
  inOutTypeCd: string;
  edhPrtclTypeCd: string;
  updateDateTimecpntEdhPrtclMngEdh: string;
  edhPrtclDisplayName: string;
  godFlg: string;
  inProgressCmpProjectId: string;
  inProgressCmpProjectName: string;
  waitingCmpProjectName: string;
  inProgressCmpProjectReqType: string;
  stgOnlyFlg: string;
  cmnt: string;
  updateDateTimeCmnt: string;
  designStatusName: string;
  designStatus: string;
  updateDateTimeDesignStatus: string;
  stgDeployStatusName: string;
  stgDeployStatus: string;
  prdDeployStatusName: string;
  prdDeployStatus: string;
  edhPrtclAttributeList: GetEdhPrtclAttribute[];
};
export type GetEdhPrtclAttribute = {
  edhPrtclAttributenum: string;
  key: string;
  stgDesignValue: string;
  updateDateTimeStgDesignValue: string;
  stgCurrentValue: string;
  prdDesignValue: string;
  updateDateTimePrdDesignValue: string;
  prdCurrentValue: string;
};
